fetch(`./assets/config/app-config.json`)
  .then((res) => res.json())
  .then((data) => (
    window.__webpack_public_path__ = (data?.publicPath?.endsWith('/') ?
      data.publicPath : (data?.publicPath || '') + '/') || '/'
  ))
  .then(() => import('./bootstrap'))
  .catch(err => console.error(err));
